<script>
	import { Link } from "svelte-routing";

	export let stripePlusPaymentLink = "";
</script>

<div class="content-box subscription-details-box">
	<div class="subscription-section">
		<div class="subscription-upgrade">
			<h4>Lås upp hela Boanalys</h4>
			<p class="upgrade-pitch">
				En bostadsaffär handlar om miljoner. För <strong
					>49 kr/månad</strong
				> får du full tillgång till alla funktioner hos Boanalys. Ett kraftfullt
				verktyg för både privatpersoner, företag och föreningar som vill
				fatta rätt beslut – och undvika dyra misstag.
			</p>

			<div class="plans-container">
				<div class="plan-card featured">
					<div class="price-section">
						<span class="price-amount">49</span>
						<span class="price-term">kr / månad</span>
					</div>
					<a
						href={stripePlusPaymentLink}
						class="cta-button"
						target="_blank"
						rel="noopener noreferrer"
					>
						Kom igång nu
					</a>
					<ul class="features-list">
						<li>Detaljerade betyg & nyckeltal</li>
						<li>
							Tillgång till underliggande dokument
							(årsredovisning, stadgar, energideklaration)
						</li>
						<li>Underlag för BRF-lån</li>
						<li>BoBot – ställ frågor direkt till vår AI</li>
						<li>Trendgrafer för ekonomisk utveckling</li>
						<li>
							Fri tillgång till all framtida utveckling och nya
							funktioner
						</li>
					</ul>
					<p class="plan-note">
						Avsluta när du vill. Inga bindningstider.
					</p>
				</div>
			</div>
		</div>
	</div>
	<p class="field-note" style="margin-top: 15px; margin-bottom: 0px;">
		** Ange samma e-postadress som du använde för att skapa ditt konto.
		<br />
		Tjänsten tillhandahålls av BOAN AB (559509-9101). Läs mer om våra <Link
			to="/legal">allmänna villkor</Link
		>.
	</p>
</div>
